import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-67557e96"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "step-progress flex w-full flex-row gap-[2px] justify-evenly" }


export default /*#__PURE__*/_defineComponent({
  __name: 'step-progress',
  props: {
    completed: null,
    toComplete: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.toComplete, (progress) => {
      return (_openBlock(), _createElementBlock("div", {
        key: progress,
        class: _normalizeClass(["progress h-[4px] bg-System/app_grey_89 self-stretch", { completed: progress <= __props.completed }])
      }, null, 2))
    }), 128))
  ]))
}
}

})